function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { RcDialog } from '../../hooks/dialog';
import { getDefaultElementPosition, getWindowSize, useElementPosition } from '@bydesign-ui/hooks';
import { useRefGetter } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import React, { useRef, useState } from 'react';
import { usePrefixCls } from '@byte-design/config';
export function Sticky(props) {
  var zIndex = props.zIndex,
      _props$topOffset = props.topOffset,
      topOffset = _props$topOffset === void 0 ? 0 : _props$topOffset,
      _props$bottomOffset = props.bottomOffset,
      bottomOffset = _props$bottomOffset === void 0 ? 0 : _props$bottomOffset,
      _props$stickyStyle = props.stickyStyle,
      stickyStyle = _props$stickyStyle === void 0 ? {} : _props$stickyStyle,
      stickyClassName = props.stickyClassName,
      children = props.children,
      className = props.className,
      style = props.style,
      extra = _objectWithoutProperties(props, ["zIndex", "topOffset", "bottomOffset", "stickyStyle", "stickyClassName", "children", "className", "style"]);

  var _useState = useState(_objectSpread({
    sticky: false,
    position: 'top'
  }, getDefaultElementPosition())),
      _useState2 = _slicedToArray(_useState, 2),
      info = _useState2[0],
      setStickyInfo = _useState2[1];

  var ref = useRef(null);
  var topOffsetGetter = useRefGetter(topOffset);
  var bottomOffsetGetter = useRefGetter(bottomOffset);
  var infoGetter = useRefGetter(info);
  var cls = classnames(usePrefixCls('sticky', {
    sticky: info.sticky
  }), className);
  var stickyCls = classnames(usePrefixCls('sticky-element', _defineProperty({
    sticky: info.sticky
  }, info.position, true)), stickyClassName);
  useElementPosition(ref, function () {
    return true;
  }, function (position) {
    var top = topOffsetGetter();
    var bottom = bottomOffsetGetter();
    var old = infoGetter();
    var winSize = getWindowSize();
    var p = position.top < top ? 'top' : position.bottom + bottom > winSize.height ? 'bottom' : false;

    if (!old.sticky && p === false) {
      return;
    }

    setStickyInfo(_objectSpread(_objectSpread({}, position), {}, {
      position: p === 'bottom' ? 'bottom' : 'top',
      sticky: p !== false
    }));
  }, {
    disabledCaptureStickyCheck: true
  });
  return React.createElement("div", Object.assign({}, extra, {
    className: cls,
    ref: ref,
    style: _objectSpread(_objectSpread({}, style), info.sticky ? {
      pointerEvents: 'none',
      visibility: 'hidden',
      opacity: 0
    } : {})
  }), info.sticky && React.createElement(RcDialog, {
    zIndex: zIndex,
    show: info.sticky,
    mask: false,
    forceFixed: true,
    preventPointerEvent: false,
    horizontal: "left",
    left: info.left,
    vertical: info.position,
    top: topOffset,
    bottom: bottomOffset
  }, React.createElement("div", {
    className: stickyCls,
    style: _objectSpread(_objectSpread({}, stickyStyle), {}, {
      width: info.width
    })
  }, children(true, info))), children(false, info));
}